const sum = (sum: number, value: number): number => sum + value;

export const sumArray = (array: number[]): number => array.reduce(sum);

/**
 *
 * @param {Object} object
 * @returns the sum of all the object's values, or NaN if the values are not all numbers
 */
export const sumValues = (object: object): number =>
  Object.values(object).reduce(sum);

/**
 * @param {number} dividend
 * @param {number} divisor1
 * @param {number} divisor2
 * @returns the quotient of the dividend and divisor(s), or 0 if the divisor(s) is 0
 */
export const errDiv = (
  dividend: number,
  divisor1: number,
  divisor2: number
): number => {
  if (divisor2 !== undefined) {
    // Checks to see if second divisor passed as argument
    return divisor1 !== 0 && divisor2 !== 0
      ? dividend / divisor1 / divisor2
      : 0;
  } else {
    return divisor1 !== 0 ? dividend / divisor1 : 0;
  }
};

const toNumber = (value: string): number => {
  const valueAsNumber = Number(value);
  if (typeof valueAsNumber !== "number" || isNaN(valueAsNumber)) {
    throw new Error(`Cannot convert ${value} to number`);
  }
  return valueAsNumber;
};

/**
 * @param values
 * @returns same object, but all values have been turned into numbers
 */
export const valuesToNumbers = (values: object): object =>
  Object.entries(values).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: toNumber(value) }),
    {}
  );

/**
 * Returns the rounded value of a number to a specified number of decimal places
 * @param {number} num Number to be rounded
 * @param {number} decimalPlaces Number of decimal places to round to
 * @returns Rounded number
 */
export const roundFloat = (num: number, decimalPlaces = 2) => {
  var p = Math.pow(10, decimalPlaces);
  var n = num * p * (1 + Number.EPSILON);
  return Math.round(n) / p;
};
